import type { SelectHTMLAttributes } from 'react'

type Option = { value: string; label: string }

type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
  options: Option[]
  error?: string
  autoWidth?: boolean
}

export function Select({ className = '', options, error, autoWidth = false, style, ...props }: SelectProps) {
  const mergedStyle = {
    ...(autoWidth ? { fieldSizing: 'content' as any, minWidth: '4rem' } : {}),
    ...style,
  }

  return (
    <div className={autoWidth ? 'inline-block' : 'w-full'}>
      <select
        className={`h-9 rounded-[var(--radius-sm)] border bg-white px-2.5 text-sm text-[var(--color-text)] outline-none focus:border-[var(--color-accent)] focus:ring-1 focus:ring-[var(--color-accent)]/30 ${
          autoWidth ? 'w-auto' : 'w-full'
        } ${error ? 'border-red-400' : 'border-[var(--color-border)]'} ${className}`}
        style={mergedStyle}
        {...props}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error ? <p className="mt-1 text-xs text-red-600">{error}</p> : null}
    </div>
  )
}
